const updateFilterDetail = (value, filterType,tableType) => {
    return {
        type: 'UPDATE_FILTER_DETAIL',
        value,
        filterType,
        tableType
    }
};
const resetTableFilters = (value) => {
    return {
        type: 'RESET_TABLE_FILTER',
        value
    }
};

const tableFilters = {
    updateFilterDetail,
    resetTableFilters
}

export default tableFilters;